import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Layout } from './components/Layout';
// Pages
import { LoginPage } from './pages/LoginPage';
import { Dashboard } from './pages/Dashboard';
import { UploadScreen } from './pages/UploadScreen';
import { ValidationScreen } from './pages/ValidationScreen';
import { ProcessingScreen } from './pages/ProcessingScreen';
import { AdminApprovalScreen } from './pages/AdminApprovalScreen';
import { KhatianViewer } from './pages/KhatianViewer';
import { SubmissionsList } from './pages/SubmissionsList';
import { ReportsPage } from './pages/ReportsPage';
import { AuditTrail } from './pages/AuditTrail';
// Protected Route Wrapper
const ProtectedRoute = ({
  children,
  allowedRoles
}: {
  children: React.ReactNode;
  allowedRoles?: string[];
}) => {
  const {
    isAuthenticated,
    user
  } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace data-id="element-0" />;
  }
  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace data-id="element-1" />;
  }
  return <Layout data-id="element-2">{children}</Layout>;
};
export function App() {
  return <AuthProvider data-id="element-3">
      <Router data-id="element-4">
        <Routes data-id="element-5">
          <Route path="/login" element={<LoginPage data-id="element-7" />} data-id="element-6" />

          <Route path="/" element={<ProtectedRoute data-id="element-9">
                <Dashboard data-id="element-10" />
              </ProtectedRoute>} data-id="element-8" />

          <Route path="/upload" element={<ProtectedRoute allowedRoles={['operator', 'zso']} data-id="element-12">
                <UploadScreen data-id="element-13" />
              </ProtectedRoute>} data-id="element-11" />

          <Route path="/submissions" element={<ProtectedRoute allowedRoles={['operator', 'officer', 'zso', 'admin']} data-id="element-15">
                <SubmissionsList data-id="element-16" />
              </ProtectedRoute>} data-id="element-14" />

          <Route path="/validate" element={<ProtectedRoute allowedRoles={['officer']} data-id="element-18">
                <ValidationScreen data-id="element-19" />
              </ProtectedRoute>} data-id="element-17" />

          <Route path="/processing" element={<ProtectedRoute allowedRoles={['officer', 'admin']} data-id="element-21">
                <ProcessingScreen data-id="element-22" />
              </ProtectedRoute>} data-id="element-20" />

          <Route path="/approve" element={<ProtectedRoute allowedRoles={['admin']} data-id="element-24">
                <AdminApprovalScreen data-id="element-25" />
              </ProtectedRoute>} data-id="element-23" />

          <Route path="/viewer" element={<ProtectedRoute data-id="element-27">
                <KhatianViewer data-id="element-28" />
              </ProtectedRoute>} data-id="element-26" />

          <Route path="/reports" element={<ProtectedRoute allowedRoles={['officer', 'zso', 'admin']} data-id="element-30">
                <ReportsPage data-id="element-31" />
              </ProtectedRoute>} data-id="element-29" />

          <Route path="/audit" element={<ProtectedRoute allowedRoles={['admin']} data-id="element-33">
                <AuditTrail data-id="element-34" />
              </ProtectedRoute>} data-id="element-32" />

          <Route path="*" element={<Navigate to="/" replace data-id="element-36" />} data-id="element-35" />
        </Routes>
      </Router>
    </AuthProvider>;
}